module.exports = __webpack_public_path__ + "img/longTextBg.003731dd.png";